import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=758820e6&scoped=true"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=758820e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758820e6",
  null
  
)

export default component.exports